// debugging helper functions
import mqtt from 'mqtt'
import uuid from 'uuid'
import mqttStore from '../store/mqtt.js'
import { sync } from 'vuex-pathify'
export default {
  computed: {
    origMqttClient: sync ('mqtt/origMqttClient'),
    mqttClient: sync ('mqtt/mqttClient'),
    mqttAuthorized: sync ('mqtt/mqttClient'),
    mqttTableUpdated: sync('mqtt/mqttTableUpdated'),
    mqttConnected: sync('mqtt/mqttConnected'),
  },
  methods: {
    endOrigMQTT() {
      if (this.origMqttClient == null) return
      this.origMqttClient.end()
      this.origMqttClient = null
    },
    endFacMQTT() {
      if (this.mqttClient == null) return
      // this.mqttClient.end()
      // this.mqttClient = null
    },
    endMQTT() {
      this.endFacMQTT()
      this.endOrigMQTT()
      this.mqttAuthorized = false
      this.mqttConnected = false
      this.elog('debug','Shut down MQTT')()
    },
    initOrigMQTT() {
      let self = this
      var origClient = mqtt.connect('wss://mqtt.entrinsia.net:8881', {
        clientId: 'Cortex-' + this.origLoggedinUser.uid + uuid.v4(),
        username: localStorage.getItem('origToken'),
        password: 'temp',
        keepalive: 60,
        reconnectPeriod: 1000 * 1,
        clean: true
      })
      var origTopic = this.origLoggedinOrg.name + '/notification/' + this.origLoggedinUser.uid
      origClient.on('connect', function () {
        self.elog('log', 'user mqtt connection established for topic: {}', origTopic)()
        self.origMqttClient = origClient
        origClient.unsubscribe(origTopic)
        origClient.subscribe(origTopic)
      })
      origClient.on('reconnect', function () {
        origClient.unsubscribe(origTopic)
        origClient.subscribe(origTopic)
      })
      origClient.on('message', function (t, message, packet) {
        try {
          var msg
          try {
            msg = JSON.parse(String.fromCharCode.apply(null, message))
          } catch (er) {
            console.log(er)
            return
          }
          self.elog('trace','mqtt message received: {}, {}', t, msg)()
          let p = t.split('/')
          if (p[1] == 'notification') {
            console.log('MESSAGE: ${msg}')
            mqttStore.state.notification = msg['objid']
          }
          if (t !== origTopic) {
            // self.elog('trace', 'Topic mismatch discarded: {}, {}', t, origTopic)()
            return
          }
        }  catch(ex) {
          console.log(ex)
        }
      })
    },
    initFacMQTT() {
      let self = this
      var client = mqtt.connect('wss://mqtt.entrinsia.net:8881', {
        clientId: 'Cortex-' + this.loggedinUser.uid + uuid.v4(),
        username: localStorage.getItem('token'),
        password: 'temp',
        keepalive: 60,
        reconnectPeriod: 1000 * 1,
        clean: true
      })
      var topic = this.loggedinOrg.name + '/dtupdates'
      client.on('connect', function () {
        self.mqttConnected = true
        self.$toasted.clear()
        self.$toasted.show('Server connection established', {type: 'success', duration: 3 * 1000})
        self.elog('log', 'mqtt connection established for topic: {}', topic)()
        self.mqttClient = client
        client.unsubscribe(topic)
        client.subscribe(topic)
      })
      client.on('error', function (error) {
        self.elog('error', 'mqtt error {}', error.message)()
        if (error.message.includes('Not authorized')) {
          
          self.mqttAuthorized = false
          self.mqttConnected = false
        }
      })
      client.on('offline', function () {
        self.elog('error', 'mqtt is offline')()
        self.$toasted.clear()
        self.$toasted.show('Server connection disrupted', {type: 'error', duration: 900 * 1000})
        self.mqttConnected = false
      })
      client.on('reconnect', function () {
        self.elog('log', 'mqtt has reconnected')()
        self.mqttConnected = true
        self.$toasted.clear()
        client.unsubscribe(topic)
        client.subscribe(topic)
        // self.$toasted.show('Server connection established', {type: 'success', duration: 2 * 1000})
      })
      client.on('message', function (t, message, packet) {
        try {
          var msg
          try {
            msg = JSON.parse(String.fromCharCode.apply(null, message))
          } catch (er) {
            return
          }
          self.elog('trace','mqtt message received: {}, {}', t, msg)()
          let p = t.split('/')
          if (p[1] == 'dtupdates') {
            self.mqttTableUpdated = msg.table
          }
          if (t !== topic) {
            self.elog('trace', 'Topic mismatch discarded: {}, {}', t, topic)()
            return
          }
        }  catch(ex) {
          console.log(ex)
        }
      })
    },
    initMQTT () {
      let self = this
      this.initOrigMQTT()
      this.initFacMQTT()
      self.elog('log', 'Initialzed MQTT')()  
    }
  }
}
